<template>
    <input type="text" v-debounce-input="{event: 'input-debounced', delay: debounce}" :value="value" v-bind="$attrs" v-on="inputListeners" />
</template>

<script>
import BaseInputComponent from '@/helpers/BaseInputComponent'

export default {
    name: 'oc-text-input',
    extends: BaseInputComponent,
    props: {
        value: [String, Number], // this is needed in order v-model to work
        debounce: {
            type: [Number, String],
            default: 0
        }
    },
    model: {
        event: 'input-debounced'
    }
}
</script>
